import QuantityScaleApi from '@/api/piglet/pigletQuantityScale';

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    async addOrUdpdate({dispatch}, {form, context}) {
      try {
        const response = await QuantityScaleApi.addOrUpdate(form, context);
        return Promise.resolve(response.data)
      } catch(error) {
        dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    },
    async fetchAll({dispatch}, {context}) {
      try {
        const response = await QuantityScaleApi.fetchAll(context);
        return Promise.resolve(response.data)
      } catch(error) {
        dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    },
    async remove({dispatch}, {id, context}) {
      try {
        const response = await QuantityScaleApi.remove(id, context);
        return Promise.resolve(response.data)
      } catch(error) {
        dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    }
  }
}
